import apiClient from './client';
import type { RichiestaDetail } from './richieste';

// Tipi (allineati a backend richieste_schemas.py ConsultazioneCreate/Rispondi).
export type ConsultazioneTipo = 'RT' | 'DIR';

export interface ApriConsultazionePayload {
  tipo: ConsultazioneTipo;
  commento_richiesta: string;
}

export interface RispondiConsultazionePayload {
  commento_risposta: string;
}

/**
 * Apre una consultazione su una richiesta (#96). Solo AMM/admin.
 * Lo stato dell'ordine passa a `in_consultazione`; `stato_pre_consultazione`
 * viene salvato per il ritorno alla risposta. 409 se ne esiste già una aperta.
 */
export async function apriConsultazione(
  richiestaId: string,
  payload: ApriConsultazionePayload,
): Promise<RichiestaDetail> {
  const { data } = await apiClient.post<RichiestaDetail>(
    `/api/richieste/${richiestaId}/consultazione`,
    payload,
  );
  return data;
}

/**
 * Risponde a una consultazione aperta. RT può rispondere solo a tipo=RT,
 * DIR solo a tipo=DIR; admin può rispondere a entrambe.
 * Chiude la consultazione e riporta l'ordine al `stato_pre_consultazione`.
 */
export async function rispondiConsultazione(
  consultazioneId: string,
  payload: RispondiConsultazionePayload,
): Promise<RichiestaDetail> {
  const { data } = await apiClient.post<RichiestaDetail>(
    `/api/consultazioni/${consultazioneId}/rispondi`,
    payload,
  );
  return data;
}
